import api from "@/shared/services/api";

//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//Mails
export const GET_INBOX_MAILS = "/inboxmails"
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail"
export const DELETE_INBOX_MAIL = "/delete/inboxmail"

//starred mail
export const GET_STARRED_MAILS = "/starredmails"

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails"

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails"

//Send mail
export const GET_SENT_MAILS = "/sentmails"

//Trash mail
export const GET_TRASH_MAILS = "/trashmails"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"
export const ADD_NEW_ORDER = "/add/order"
export const UPDATE_ORDER = "/update/order"
export const DELETE_ORDER = "/delete/order"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"
export const ADD_NEW_CUSTOMER = "/add/customer"
export const UPDATE_CUSTOMER = "/update/customer"
export const DELETE_CUSTOMER = "/delete/customer"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"
export const ADD_INVOICE = "/add/invoice"
export const DELETE_INVOICE = "/delete/invoice"
export const UPDATE_INVOICE = "/update/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"
export const ADD_NEW_PROJECT = "/add/project"
export const UPDATE_PROJECT = "/update/project"
export const DELETE_PROJECT = "/delete/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"
export const ADD_NEW_USER = "/add/user"
export const UPDATE_USER = "/update/user"
export const DELETE_USER = "/delete/user"

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data"
export const GET_YEARLY_DATA = "/yearly-data"
export const GET_MONTHLY_DATA = "/monthly-data"

export const TOP_SELLING_DATA = "/top-selling-data"

export const GET_EARNING_DATA = "/earning-charts-data"

export const GET_PRODUCT_COMMENTS = "/comments-product"

export const ON_LIKNE_COMMENT = "/comments-product-action"

export const ON_ADD_REPLY = "/comments-product-add-reply"

export const ON_ADD_COMMENT = "/comments-product-add-comment"

export const  GET_MARKET_OVERVIEW = "GET_MARKET_OVERVIEW"
export const GET_MARKET_OVERVIEW_SUCCESS = "GET_MARKET_OVERVIEW_SUCCESS"
export const GET_MARKET_OVERVIEW_FAIL = "GET_MARKET_OVERVIEW_FAIL"

export const GET_WALLENT_BALANCE = "GET_WALLENT_BALANCE"

export const GET_WALLENT_BALANCE_ALL_DATA = "GET_MARKET_ALL_DATA"

export const GET_Invested_Overview = "GET_Invested_Overview"

export const urlApi = {
    auth: {
      login: "/auth/login",
      register: "/auth/register",
      logout: "/auth/logout",
      forgotPassword: "/auth/forgot-password",
      resetPassword: "/auth/reset-password",
      verifyEmail: "/auth/verify-email",
      refreshToken: "/admin/refresh-token",
      diditSession: "/verification/session",
      diditVerify: "/verification/retrieve",
    },
    atributes: {
      civilState: "/atributos/estado-civil",
      coin: "/atributos/moneda",
      condition: "/atributos/condicion",
      conditionHousing: "/atributos/condicion-vivienda",
      country: "/atributos/pais",
      countryPermanentResidence: "/atributos/pais-residencia-permanente",
      destinationFunds: "/atributos/destino-fondos",
      documentType: "/atributos/tipo-documento",
      familyBurden: "/atributos/carga-familiar",
      gender: "/atributos/genero",
      incomeGeneratingActivity: "/atributos/actividad-generadora-ingresos",
      investmentType: "/atributos/tipo-inversion",
      isPep: "/atributos/es-pep",
      levelKnowledge: "/atributos/nivel-conocimiento",
      nationality: "/atributos/nacionalidad",
      professionTrade: "/atributos/profesion-oficio",
      products: "/atributos/productos",
      productAccount: "/atributos/cuenta-producto",
      productName: "/atributos/nombre-producto",
      productSpecification: "/atributos/especificacion-producto",
      reasonRequestService: "/atributos/motivo-solicitud-servicio",
      relatedPep: "/atributos/relacionado-pep",
      riskLevel: "/atributos/nivel-riesgo",
      sourceFunds: "/atributos/origen-fondos",
      sourceIncome: "/atributos/fuente-ingresos",
      specialCategory: "/atributos/categoria-especial",
      time: "/atributos/tiempo",
      typeInstrument: "/atributos/tipo-instrumento",
      virtualCurrency: "/atributos/moneda-virtual",
      yearsExperience: "/atributos/anos-experiencia",
      yesOrNot: "/atributos/si-no",
    }
  
  }
  

export const getData = async (url: string) => {
    try {
      const response = await api.get(url);
      if (response.status === 200) {
        const data: any = [];
        response.data.data.map((element: { id: number; nombre: string }) => {
          data.push({ value: element.id, label: element.nombre });
        });
        return data;
      }
    } catch (error) {
      console.error(error);
    }
  }
  



